import { useEffect, useState } from 'react';
import { navItems } from '@/mocks/home';

function scrollToId(id: string) {
  const el = document.getElementById(id);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - 96;
    window.scrollTo({ top, behavior: 'smooth' });
  }
}

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (id: string) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed top-9 left-0 right-0 z-40 border-b transition-colors duration-300 ${
        scrolled ? 'border-background-200 bg-background-50/95 backdrop-blur' : 'border-transparent bg-background-50/70 backdrop-blur'
      }`}
    >
      <div className="mx-auto flex h-16 max-w-shell items-center justify-between gap-4 px-4 md:px-6">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="flex items-center gap-2.5 text-left"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950">
            <span className="font-label text-lg leading-none text-primary-400">51</span>
          </span>
          <span className="leading-tight">
            <span className="block font-label text-xl tracking-wide text-foreground-950">51黑料</span>
            <span className="block text-[11px] tracking-[0.2em] text-foreground-500">地址 · 入口 · 索引</span>
          </span>
        </button>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => handleNav(item.id)}
              className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => handleNav('entry')}
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            查看最新入口
          </button>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto grid grid-cols-2 gap-2 px-4 py-3">
            {navItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => handleNav(item.id)}
                className="rounded-md bg-background-100 px-3 py-2.5 text-left text-sm text-foreground-800"
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}